import GloLogo from "../img/glo-logo.svg";
import PagesHeader from "@components/PagesHeader";
const ContestFinish = () => {
  return (
    <section className="your-glo-story-page finish">
      <PagesHeader>
        <strong>Deine</strong> glo-Story
      </PagesHeader>

      <div className="hero-section-finish">
        <div className="content">
          <img src={GloLogo} alt="glo" className="logo" />
          <h2 className="title">
            <strong>
              Das glo-Story <br />
              Event ist&nbsp;vorbei
            </strong>
          </h2>
          <p className="desc">
            Wir haben die Gewinner
            <br /> per E-Mail benachrichtigt. <br />
            Glückwunsch an alle!
          </p>
        </div>
      </div>
    </section>
  );
};
export default ContestFinish;
